export class FormulaireAutorisationIntervention {
    id: number;
    fiche_intervention_id: number;
    nom_assure: string;
    adresse_domicile: string;
    adresse_propriete_endommagee: string;
    compagnie_assurance: string;
    no_police_assurance: string;
    no_dossier_intervention: string;
    nom_expert_sinistre: string;
    nom_compagnie_expertise: string;
    signature_client: string;
    courriel_client: string;
    commentaire_signature: string;
    fermer: boolean;
    nom_pdf_signe: string;
    pdf_signe: string;

    public constructor(init?: Partial<FormulaireAutorisationIntervention>) {
        Object.assign(this, init);
    }
}
